import styled from 'styled-components';
import { getSpace } from '../../../stylesheets/tools';

const StyledLink = styled.a`
  display: inline-flex;
  align-items: center;

  .link__icon {
    margin-left: ${getSpace('8px')};
    height: 11px;
    width: 17px;
    margin-top: -4px;
    transition: transform 0.2s ease-in-out;
  }

  &:hover .link__icon {
    transform: translateX(2px);
  }
`;

export default StyledLink;
